<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <div class="transfer-content">
          <div class="company-logo">
            <img class="logo" src="../assets/forchange-logo.png" alt="" />
          </div>
          <div class="animation-logo">
            <div class="item">
              <div class="animation-box-one"></div>
            </div>
            <div class="item">
              <div class="animation-box-two"></div>
            </div>
            <div class="item">
              <div class="animation-box-three"></div>
            </div>
          </div>
          <div class="wechat-logo">
            <img class="logo" src="../assets/wechat-logo.png" alt="" />
          </div>
        </div>
        <div class="text-content">正在打开小程序前往激活课程...</div>
      </div>
    </div>

    <div class="tips">
      <div class="tips-title">
        <div class="small-icon"></div>
        <div class="text">若小程序跳转失败，请尝试以下方法</div>
      </div>
      <div class="tips-content">
        <div class="content-rule">
          1. 如果没有自动跳转，请点击按钮<span
            class="open-applet-tip"
            @click="linkTo"
            >打开小程序</span
          >
        </div>
        <div class="content-rule">
          2. 请点击<span class="copy" @click="copyUrl">复制</span
          >，并在微信中打开
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import toast, { ToastType } from '@/basic/components/Toast';
import { USER_INFO_STORAGE } from '../constants';
import { postUrlSchemeLog } from '../request';
import { transformTime } from '../helper'

@Component({
  components: {},
  beforeRouteEnter: (to: any, from: any, next: Function) => {
    window.Al.start();
    window.np.start();
    next(async (vm: AppletTransferPage) => {
      await vm.fetchAppletParams();
      window.Al.done();
      window.np.done();
    });
  },
})
export default class AppletTransferPage extends Vue {
  redirect_url = '';
  page_url = '';
  linkTo() {
    if (window.location) {
      window.location.href = this.redirect_url;
    } else {
      toast({
        type: ToastType.failure,
        value: '请尝试在微信中打开',
      });
    }
  }

  copyUrl() {
    const input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', this.page_url);
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 9999);
    if (document.execCommand('copy')) {
      document.execCommand('copy');
    }
    document.body.removeChild(input);
    toast({
      type: ToastType.success,
      value: '复制成功',
    });
  }

  async fetchAppletParams() {
    const { id } = this.$route.query;
    const currentStorageName = `${USER_INFO_STORAGE}-${id}`;

    const storage = localStorage.getItem(currentStorageName);

    // 非首次进入
    if (storage) {
      const { page_url, redirect_url, first_view_time, view_count } =
        JSON.parse(storage);
      this.redirect_url = redirect_url || '';
      this.page_url = page_url || '';

      if (redirect_url) {
        localStorage.setItem(
          currentStorageName,
          JSON.stringify({
            redirect_url,
            page_url,
            first_view_time,
            // 更新进入次数
            view_count: view_count + 1,
          })
        );

        // 发送埋点
        await postUrlSchemeLog({
          first_view_time,
          last_view_time: transformTime((new Date().getTime() / 1000)),
          id: Number(id),
          url: this.redirect_url,
          view_count: view_count + 1,
        });

        this.linkTo();
        return;
      }
    }

    const params = {
      urlscheme_id: id ? Number(id) : null,
    };
    const {
      data: { redirect_url, page_url },
    } = await window.apis.getSchemeParams(params);
    this.redirect_url = redirect_url || '';
    this.page_url = page_url || '';

    const firstViewTime = transformTime(new Date().getTime() / 1000);

    localStorage.setItem(
      currentStorageName,
      JSON.stringify({
        redirect_url,
        page_url,
        // 首次进入
        first_view_time: firstViewTime,
        view_count: 1,
      })
    );

    // 发送埋点
    await postUrlSchemeLog({
      first_view_time: firstViewTime,
      last_view_time: firstViewTime,
      id: Number(id),
      url: this.redirect_url,
      view_count: 1,
    });

    this.linkTo();
  }
}
</script>

<style scoped lang="scss">
@import './applet-page.scss';
</style>